import { useEffect } from "react";

const FacebookSDK = () => {
  const appId = "1169976494913346";
  const graphApiVersion = "v22.0"; // Example: 'v18.0'

  useEffect(() => {
    // Load Facebook SDK if not already loaded
    if (!window.FB) {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: appId,
          xfbml: true,
          version: graphApiVersion,
        });
      };

      const script = document.createElement("script");
      script.id = "facebook-jssdk";
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      document.body.appendChild(script);
    }

    // Cleanup function to remove the script on unmount
    return () => {
      const fbScript = document.getElementById("facebook-jssdk");
      if (fbScript) {
        fbScript.remove();
      }
      delete window.FB;
    };
  }, []);

  return null; // This component doesn't render UI, only loads SDK
};

export default FacebookSDK;
